<template>
  <v-card>
    <v-divider></v-divider>
      <v-card-title>
        <div class="headline">Permission</div>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-title>
        <v-flex xs12 v-if="messages">
          <message :messages="messages"></message>
        </v-flex>
        <v-flex xs4>
          <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
        </v-flex>
        <v-flex xs4>
          <cal-picker :label="labels.effDate" v-model="searchEffDate" @change="fetchData(commonForm.cover, searchEffDate)"></cal-picker>
        </v-flex>
        <v-flex xs4>
          <v-layout row>
            <v-spacer></v-spacer>
            <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
              <v-btn color="secondary" class="white--text" slot="activator">
                <span>Columns</span>
                <v-icon right dark>mdi-table-column-plus-after</v-icon>
              </v-btn>
              <v-card>
                <v-card-text>
                  <template v-if="columns.length > 0">
                    <v-checkbox v-for="column in columns" :key="column.value" :label="column.text" :value="column.value" v-model="selectedColumns"></v-checkbox>
                  </template>
                  <template v-else>
                    No column found
                  </template>
                </v-card-text>
              </v-card>
            </v-menu>
          </v-layout>
        </v-flex>
      </v-card-title>
      <v-data-table v-bind:headers="listHeaders" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="benefit" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
        <template slot="items" slot-scope="props">
        <td v-for="column in selectedColumns" :key="column">
          {{props.item[column]}}
        </td>
        <td class="text-xs-right">
          <table-action :rowData="props" :review="checkAccess(['motorRatingReview'])" @review="doPermStatusReview" remove @remove="doPromptRemove(props.item)"></table-action>
        </td>
        </template>
      </v-data-table>
      <v-btn color="primary" dark class="mb-2" @click="doNewMtrPermStatusForm">New Permission Status<v-icon>mdi-plus</v-icon></v-btn>
      <v-dialog v-model="reviewMtrPermitStatus" max-width="900px" persistent>
        <v-card>
          <v-card-title v-if="newMtrPermitStatus">
            <span class="headline">New Motor Permission Status</span>
          </v-card-title>
          <v-card-title v-else>
            <span class="headline">Motor Permission Status</span>
          </v-card-title>
          <form data-vv-scope="mtrPermStatusForm">
            <v-card-text>
              <message :messages="messages"></message>
              <v-container fluid grid-list-lg>
                <v-layout row wrap v-if="newMtrPermitStatus">
                  <v-flex xs4>
                    <v-autocomplete data-vv-scope="mtrPermStatusForm" :items="mtrStatusFieldDescList()" v-model="mtrPermStatusForm.statusField" :label="labels.statusField" item-text="label" item-value="value" data-vv-name="statusField" :data-vv-as="labels.statusField" :error-messages="errors.collect('mtrPermStatusForm.statusField')" v-validate="'required'" @change="doOperatorList"></v-autocomplete>
                  </v-flex>
                  <v-flex xs4 v-if="isDrv">
                    <v-autocomplete data-vv-scope="mtrPermStatusForm" :hint="mtrPermStatusForm.statusField===null? 'Please Choose Status Field First':''" :persistent-hint="mtrPermStatusForm.statusField===null" :no-data-text="labels.statusHint" :items="operatorList" v-model="mtrPermStatusForm.statusVal" :label="labels.statusVal" item-text="label" item-value="value" data-vv-name="statusVal" :data-vv-as="labels.statusVal" :error-messages="errors.collect('mtrPermStatusForm.statusVal')" v-validate="'required'"></v-autocomplete>
                  </v-flex>
                  <v-flex xs4 v-if="isDrv">
                  </v-flex>
                  <v-flex xs4 v-if="!isDrv">
                    <v-autocomplete data-vv-scope="mtrPermStatusForm" :hint="mtrPermStatusForm.statusField===null? 'Please Choose Status Field First':''" :persistent-hint="mtrPermStatusForm.statusField===null" :no-data-text="labels.statusHint" :items="operatorList" v-model="mtrPermStatusForm.operator" :label="labels.operator" item-text="label" item-value="value" data-vv-name="operator" :data-vv-as="labels.operator" :error-messages="errors.collect('mtrPermStatusForm.operator')" v-validate="'required'"></v-autocomplete>
                  </v-flex>
                  <v-flex xs4 v-if="!isDrv">
                    <v-text-field data-vv-scope="mtrPermStatusForm" v-model="mtrPermStatusForm.statusVal" :label="labels.statusVal" :error-messages="errors.collect('mtrPermStatusForm.statusVal')" data-vv-name="statusVal" :data-vv-as="labels.statusVal" v-validate="'required|entry|max:50'"></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                    <cal-picker data-vv-scope = "mtrPermStatusForm" :label="labels.effDate" v-model="mtrPermStatusForm.effDate" :error-messages="errors.collect('mtrPermStatusForm.effDate')" data-vv-name="effDate" :data-vv-as="labels.effDate" v-validate="'required'"></cal-picker>
                  </v-flex>
                  <v-flex xs4>
                    <cal-picker data-vv-scope = "mtrPermStatusForm" :label="labels.endDate" v-model="mtrPermStatusForm.endDate" :error-messages="errors.collect('mtrPermStatusForm.endDate')" data-vv-name="endDate" :data-vv-as="labels.endDate" :min="mtrPermStatusForm.effDate" ></cal-picker>
                  </v-flex>
                  <v-flex xs4>
                    <v-autocomplete data-vv-scope = "mtrPermStatusForm" :items="permitStatusList()" v-model="mtrPermStatusForm.permitStatus" :label="labels.permitStatus" item-text="label" item-value="value" data-vv-name="permitStatus" :data-vv-as="labels.permitStatus" :error-messages="errors.collect('mtrPermStatusForm.permitStatus')" v-validate="'required'"></v-autocomplete>
                  </v-flex>
                </v-layout>
                <v-layout row wrap v-else>
                  <v-flex xs4>
                    <v-subheader class="queryLabel">{{labels.statusField}}</v-subheader>
                    <div class="title">{{mtrPermStatusForm.statusFieldDesc}}</div>
                  </v-flex>
                  <v-flex xs4>
                    <v-subheader class="queryLabel">{{labels.operator}}</v-subheader>
                    <div class="title">{{mtrPermStatusForm.operatorDesc}}</div>
                  </v-flex>
                  <v-flex xs4>
                    <v-subheader class="queryLabel">{{labels.statusVal}}</v-subheader>
                    <div class="title">{{mtrPermStatusForm.statusVal}}</div>
                  </v-flex>
                  <v-flex xs4>
                    <v-subheader class="queryLabel">{{labels.effDate}}</v-subheader>
                    <div class="title">{{formatDate(mtrPermStatusForm.effDate)}}</div>
                  </v-flex>
                  <v-flex xs4>
                    <cal-picker data-vv-scope = "mtrPermStatusForm" :label="labels.endDate" v-model="mtrPermStatusForm.endDate" :error-messages="errors.collect('mtrPermStatusForm.endDate')" data-vv-name="endDate" :data-vv-as="labels.endDate" :min='mtrPermStatusForm.effDate'></cal-picker>
                  </v-flex>
                  <v-flex xs4>
                    <v-autocomplete data-vv-scope = "mtrPermStatusForm" :items="permitStatusList()" v-model="mtrPermStatusForm.permitStatus" :label="labels.permitStatus" item-text="label" item-value="value" data-vv-name="permitStatus" :data-vv-as="labels.permitStatus" :error-messages="errors.collect('mtrPermStatusForm.permitStatus')" v-validate="'required'"></v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" flat @click.native="doCloseMtrPermStatusForm">Cancel</v-btn>
            <v-btn color="primary" flat type="submit" :loading="submitting" @click.prevent="doSaveMtrPermStatusForm">
              {{newMtrPermitStatus ? 'Save Permission Status' : 'Update Permission Status'}}
              <v-icon right>{{newMtrPermitStatus ? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
            </v-btn>
          </v-card-actions>
          </form>
        </v-card>
        <confirm v-model="promptRemove" @ok="doRemove">
        Are you sure that you want to delete the selected Business Class Statistic?
          <div class="title">{{deleteMtrStatus}}</div>
        </confirm>
      </v-dialog>
  </v-card>
</template>

<script>
import { listMixin } from '../../listMixin.js'
import { expandURI } from '@/utils/ajax'
import FieldMixin from '@/mixins/field'
import { extractMenu } from '@/utils/extract'
import { mtrStatusFieldDesc, mtrPermitStatus, mtrStatusField } from '@/const/underwriting/motor'
export default {
  data() {
    return {
      columns: [
        { text: 'Status Field', value: 'statusFieldDesc' },
        { text: 'Operator', value: 'operatorDesc' },
        { text: 'Status Value', value: 'statusVal' },
        { text: 'Permission Status', value: 'permitStatusDesc' },
        { text: 'Effective Date', value: 'effDate' },
        { text: 'End Date', value: 'endDate' }
      ],
      selectedColumns: ['statusFieldDesc', 'operatorDesc', 'statusVal'],
      mtrPermStatusForm: {
        statusField: null,
        statusFieldDesc: null,
        operator: null,
        statusVal: null,
        permitStatus: null,
        effDate: null,
        endDate: null
      },
      labels: {
        statusField: 'Status Field',
        operator: 'Operator',
        statusVal: 'Status Value',
        permitStatus: 'Permission Status',
        effDate: 'Effective Date',
        endDate: 'End Date',
        statusHint: 'Please Choose the Status Field first'
      },
      searchEffDate: null,
      operatorList: [],
      isDrv: false,
      newMtrPermitStatus: false,
      reviewMtrPermitStatus: false,
      submitting: false,
      deleteMtrStatus: '',
      promptRemove: false,
      menu: []
    }
  },
  computed: {
    busClsMenu() {
      return this.$store.state.parameters.busCls.busClsMenu.menu
    }
  },
  watch: {
    'searchEffDate': function(value) {
      this.fetchData(this.id, value)
    }
  },
  methods: {
    async fetchData(busCls, effDate) {
      const apiURI = this.busClsMenu.mtrPermStatusList
      if (apiURI) {
        try {
          const expand = {
            busCls: busCls,
            effDate: effDate
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            this.items = []
            data.map((mtrPermStatus) => {
              const convertList = {
                effDate: this.formatDate(mtrPermStatus.effDate),
                endDate: this.formatDate(mtrPermStatus.endDate),
                operator: mtrPermStatus.operator,
                operatorDesc: mtrPermStatus.operatorDesc,
                permitStatus: mtrPermStatus.permitStatus,
                permitStatusDesc: mtrPermStatus.permitStatus + ' - ' + mtrPermitStatus[mtrPermStatus.permitStatus],
                statusFieldDesc: mtrPermStatus.statusField + ' - ' + mtrStatusFieldDesc[mtrPermStatus.statusField],
                statusField: mtrPermStatus.statusField,
                statusVal: mtrPermStatus.statusVal
              }
              this.items.push(convertList)
            })
            this.loading = false
          } else {
            this.items = []
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url - Motor Permission Status List')
      }
    },
    async doPermStatusReview(item) {
      const apiURI = this.busClsMenu.mtrPermStatusGet
      if (apiURI) {
        try {
          const expand = {
            busCls: this.id,
            statusField: item.item.statusField,
            operator: item.item.operator,
            statusVal: item.item.statusVal,
            effDate: item.item.effDate
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result.data
          if (data) {
            // Init Form
            this.mtrPermStatusForm.statusField = data.mtrPermStatus.statusField
            this.mtrPermStatusForm.statusFieldDesc = item.item.statusFieldDesc
            this.mtrPermStatusForm.operator = data.mtrPermStatus.operator
            this.mtrPermStatusForm.operatorDesc = item.item.operatorDesc
            this.mtrPermStatusForm.statusVal = data.mtrPermStatus.statusVal
            this.mtrPermStatusForm.permitStatus = data.mtrPermStatus.permitStatus
            this.mtrPermStatusForm.effDate = data.mtrPermStatus.effDate
            this.menu = extractMenu(result.data._links)
            // control
            this.reviewMtrPermitStatus = true
            this.newMtrPermitStatus = false
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url - Motor Permission Status Review')
      }
    },
    doClearMtrPermStatusForm() {
      this.mtrPermStatusForm.statusField = null
      this.mtrPermStatusForm.statusFieldDesc = null
      this.mtrPermStatusForm.operator = null
      this.mtrPermStatusForm.operatorDesc = null
      this.mtrPermStatusForm.statusVal = null
      this.mtrPermStatusForm.permitStatus = null
      this.mtrPermStatusForm.effDate = null
      this.mtrPermStatusForm.endDate = null
      this.operatorList = []
      this.resetValidator()
      this.resetMessages()
    },
    doNewMtrPermStatusForm() {
      this.doClearMtrPermStatusForm()
      this.newMtrPermitStatus = true
      this.reviewMtrPermitStatus = true
    },
    doCloseMtrPermStatusForm() {
      this.doClearMtrPermStatusForm()
      this.newMtrPermitStatus = false
      this.reviewMtrPermitStatus = false
      this.isDrv = false
    },
    doSaveMtrPermStatusForm() {
      this.resetMessages()
      this.$validator.validateAll('mtrPermStatusForm').then(result => {
        if (result) {
          if (this.newMtrPermitStatus) {
            this.doCreateMtrPermStatusForm()
          } else {
            this.doUpdateMtrPermStatusForm()
          }
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async doCreateMtrPermStatusForm() {
      const apiURI = this.busClsMenu.mtrPermStatusCreate
      if (apiURI) {
        try {
          const formatForm = {
            busCls: this.id,
            statusField: this.mtrPermStatusForm.statusField,
            operator: this.mtrPermStatusForm.operator,
            statusVal: this.mtrPermStatusForm.statusVal,
            permitStatus: this.mtrPermStatusForm.permitStatus,
            effDate: this.mtrPermStatusForm.effDate,
            endDate: this.mtrPermStatusForm.endDate
          }
          const result = await this.$http.post(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCloseMtrPermStatusForm()
            this.fetchData(this.id, this.searchEffDate)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url - Motor Permission Status Create')
      }
    },
    async doUpdateMtrPermStatusForm() {
      const apiURI = this.menu.mtrPermStatusUpdate
      if (apiURI) {
        try {
          const formatForm = {
            busCls: this.id,
            statusField: this.mtrPermStatusForm.statusField,
            operator: this.mtrPermStatusForm.operator,
            statusVal: this.mtrPermStatusForm.statusVal,
            permitStatus: this.mtrPermStatusForm.permitStatus,
            effDate: this.mtrPermStatusForm.effDate,
            endDate: this.mtrPermStatusForm.endDate
          }
          const result = await this.$http.put(apiURI, formatForm)
          const { data } = result
          if (data) {
            this.notify(data)
            this.doCloseMtrPermStatusForm()
            this.fetchData(this.id, this.searchEffDate)
          }
        } catch (error) {
          const { data } = error.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('Invalid API Url - Motor Permission Status Update')
      }
    },
    permitStatusList() {
      const list = Object.freeze(mtrPermitStatus)
      let convertArray = Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
      return convertArray
    },
    mtrStatusFieldDescList() {
      const list = Object.freeze(mtrStatusFieldDesc)
      let convertArray = Object.keys(list).map(key => {
        return {
          label: key + ' - ' + list[key],
          value: key
        }
      })
      return convertArray
    },
    doOperatorList(statusField) {
      this.operatorList = []
      if (statusField === mtrStatusField.ISDRV) {
        const list = [
          { label: 'Yes - true', value: 'true' },
          { label: 'No - false', value: 'false' }
        ]
        this.isDrv = true
        this.mtrPermStatusForm.operator = '=='
        Object.assign(this.operatorList, list)
      } else {
        const list = [
          { label: 'Equal', value: '==' },
          { label: 'Greater Than', value: '>' },
          { label: 'Greater Than Equal', value: '>=' },
          { label: 'Less Than', value: '<' },
          { label: 'Less Than Equal', value: '<=' }
        ]
        this.isDrv = false
        this.mtrPermStatusForm.operator = null
        this.mtrPermStatusForm.statusVal = null
        Object.assign(this.operatorList, list)
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedMtrStatus = data
        this.deleteMtrStatus = this.id + ' - ' + data.statusField
      }
    },
    async doRemove() {
      const apiURI = this.$store.state.parameters.busCls.busClsMenu.menu.mtrPermStatusDelete
      if (apiURI) {
        this.loading = true
        const formatForm = {
          busCls: this.id,
          statusField: this.selectedMtrStatus.statusField,
          operator: this.selectedMtrStatus.operator,
          statusVal: this.selectedMtrStatus.statusVal,
          permitStatus: this.selectedMtrStatus.permitStatus,
          effDate: this.formatDateToString(this.selectedMtrStatus.effDate),
          endDate: this.formatDateToString(this.selectedMtrStatus.endDate)
        }
        try {
          const result = await this.$http.post(apiURI, formatForm)
          this.notify(result.data)
          // Reinit
          this.fetchData(this.id, null)
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$snotify.error('Invalid API URL - Delete Motor Permission Status')
      }
    },
    formatDateToString(date) {
      switch (date) {
        case null: {
          return null
        }
        case undefined: {
          return null
        }
        case '': {
          return null
        }
        default: {
          const dateString = date
          const dateParts = dateString.split('/')
          return new Date(dateParts[2], dateParts[1] - 1, dateParts[0])
        }
      }
    }
  },
  mounted() {
    this.fetchData(this.id, this.searchEffDate)
  },
  props: ['id'],
  mixins: [
    listMixin,
    FieldMixin
  ]
}
</script>

<style>

</style>
